import { PerspectiveCamera as ThreePerspectiveCamera, Color } from 'three';

class PerspectiveCamera extends ThreePerspectiveCamera {
  constructor(fov, aspect, near, far) {
    super(fov, aspect, near, far);
    this.clear_color = new Color('#000000');
    this.clear_alpha = 1;
  }
}

export { PerspectiveCamera };
